/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetOrganizationPaymentPlanResponseDataFromJSON, GetOrganizationPaymentPlanResponseDataToJSON } from './GetOrganizationPaymentPlanResponseData';
export function GetOrganizationPaymentPlanResponseFromJSON(json) {
    return GetOrganizationPaymentPlanResponseFromJSONTyped(json, false);
}
export function GetOrganizationPaymentPlanResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: json['status'],
        data: GetOrganizationPaymentPlanResponseDataFromJSON(json['data'])
    };
}
export function GetOrganizationPaymentPlanResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: value.status,
        data: GetOrganizationPaymentPlanResponseDataToJSON(value.data)
    };
}
